import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { InAppReview } from '@capacitor-community/in-app-review';

import { isAndroidCapacitor } from 'utils/platform';

import actions from './actions';
import selectors from './selectors';

export const useBrandReviewPrompt = () => {
  const dispatch = useDispatch();
  const modalIsOpen = useSelector(selectors.getModalStep);
  const canReview = useSelector(selectors.canReview);

  const open = useCallback(async () => {
    if (isAndroidCapacitor()) {
      try {
        await InAppReview.requestReview();
      } catch (error) {
        console.error('[InAppReview] Failed to show native review:', error);
        dispatch(actions.setModalStep('prompt'));
      }
    } else {
      dispatch(actions.setModalStep('prompt'));
    }
  }, [dispatch, modalIsOpen, canReview]);

  return { canReview, open } as const;
};
